import { mainOrgSegmentedRoutes } from 'modules/main/main.routes';
import { useAppRouteParams } from 'utils/routing/useAppRouteParams';

import { ViewOrgPageContainer } from './ViewOrgPageContainer';

export default function ViewOrgPageContainerWrapper() {
  const { orgIdDashSlug } = useAppRouteParams(mainOrgSegmentedRoutes[0]);

  return <ViewOrgPageContainer orgId={orgIdDashSlug.split('-')[0]} />;
}
